module.exports = __webpack_public_path__ + "img/project-2.f85a9172.jpg";